import { gql } from "@apollo/client";

// Liefert die Details eines einzelnen Service-Jobs anhand seiner ID.
export const FETCH_SERVICE_JOB = gql`
    query FetchServiceJob($id: String!) {
        serviceJob(id: $id) {
            id
            type
            status
            submittedAt
            startedAt
            completedAt
            estimatedCompletion
            inputData
            resultData
            resultFiles
        }
    }
`; 